import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { DocumentTemplate, DocumentTemplateDetails, SaveDocumentTemplate } from './document-template-administration-model';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateAdministrationService {

  constructor(private httpService: HttpService) { }

  public loadTemplates(): Observable<DocumentTemplate[]> {
    return this.httpService.postWithContext(environment.documentTemplateAdminEndpoint + '/templates', {});
  }

  public loadDetails(templateId: number): Observable<DocumentTemplateDetails> {
    return this.httpService.postWithContext(environment.documentTemplateAdminEndpoint + '/details', templateId);
  }

  public deleteTemmplate(templateId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.documentTemplateAdminEndpoint + '/delete', templateId);
  }

  public saveDetails(details: SaveDocumentTemplate): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.documentTemplateAdminEndpoint + '/save', details);
  }
}
